// ---------------------------------------
// Iframes.js
// Sets proper sizes to iframe on load
// ---------------------------------------

const Iframes = {
    Init: function () {
        if ($('.js-forms-iframe').length) {
            $('.js-forms-iframe').each(function () {
                $(this).on('load', function () {
                    $(this).removeAttr('height');
                    $(this).css({
                        'height': ''
                    });
                    $(this).iFrameResize();
                });
            });
        }
        // ODCHYTAVANIE FB IFRAME PRI DARK MODE
        var iframes = $('.-dark-theme .c-rte iframe');
        iframes.each(function() {
            var src = $(this).attr('src');
            if (src && src.startsWith('https://www.facebook.com/')) {
                $(this).css('background-color', '#fff');
            }
        });
    }    
};

window.Iframes = Iframes;
export default Iframes;